import React, { useEffect } from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

/** In-app YouTube player (no leaving the site). */
export default function VideoModal({ open, onOpenChange, videoId, title }) {
  // The YouTube iframe steals keyboard focus, so Radix never sees Escape.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onOpenChange(false);
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [open, onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        className="max-w-5xl border-0 bg-slate-950 p-0 shadow-2xl sm:rounded-2xl [&>button:last-child]:hidden"
      >
        <DialogTitle className="sr-only">{title || "Video"}</DialogTitle>

        <div className="flex items-center justify-between gap-4 px-5 py-3">
          <div className="min-w-0">
            <p className="truncate font-heading text-[15px] font-semibold text-white">
              {title || "Video"}
            </p>
            <p className="text-[12px] text-white/55">Involvement Volunteers International</p>
          </div>
          <button
            type="button"
            aria-label="Close video"
            onClick={() => onOpenChange(false)}
            className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-white/10 text-white transition-colors duration-200 hover:bg-ivi-green"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="aspect-video w-full bg-black">
          {open && videoId && (
            <iframe
              className="h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
              title={title || "Video"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
